'use client';

import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';

interface TopStoriesCardProps {
  date: string;
  title: string;
  body: string;
}

// Custom renderer for bold text to show tickers in gold
const components: Components = {
  strong: ({ children, ...props }) => (
    <strong className="text-[#d4a853] font-semibold" {...props}>{children}</strong>
  ),
};

export function TopStoriesCard({ date, title, body }: TopStoriesCardProps) {
  return (
    <div className="p-5 bg-[#0d1117] rounded-xl border-l-[3px] border-[#d4a853] transition-all duration-200 hover:bg-[#161b22] hover:translate-x-0.5">
      <div className="text-[11px] text-[#d4a853] font-medium mb-2.5 tracking-wide uppercase">{date}</div>
      <h3 className="font-display text-lg font-semibold text-[#e6edf3] mb-3 leading-snug">{title}</h3>
      <div className="text-reading-sm text-[#8b949e] leading-relaxed prose prose-invert prose-sm max-w-none line-clamp-4">
        <ReactMarkdown components={components}>{body}</ReactMarkdown>
      </div>
    </div>
  );
}
